import { blupayApi } from "../api/client";

export const notificationsService = {
  async list({ limit = 50, offset = 0 } = {}) {
    const { data } = await blupayApi.get("/me/notifications", {
      params: { limit, offset },
    });
    return data;
  },
  async unreadCount() {
    const { data } = await blupayApi.get("/me/notifications/unread-count");
    return data;
  },
  async markRead(notificationId) {
    const { data } = await blupayApi.patch(`/me/notifications/${notificationId}/read`);
    return data;
  },
  async markAllRead() {
    const { data } = await blupayApi.post("/me/notifications/read-all");
    return data;
  },
};